import type { Step } from "react-joyride";

export const leaveApprovalListTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຫນ້າອະນຸມັດລາ. ເບິ່ງ ແລະ ອະນຸມັດ ຫຼື ປະຕິເສດຄຳຂໍລາຈາກພະນັກງານ. ກົດ 'ທົດລອງທົດສອບ' ເພື່ອເລີ່ມທົດສອບການນຳທາງ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="leave-approval-toolbar"]',
    content: "ຫົວຂໍ້ຫນ້າ ແລະ ປຸ່ມສ້າງຄຳຂໍລາພັກໃໝ່. ກົດປຸ່ມວົງມົນເພື່ອເລີ່ມທົດສອບການນຳທາງ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="leave-approval-filter"]',
    content: "ກັ່ນຕອງຕາມປີ, ເດືອນ, ຕາມວັນທີສົ່ງ ຫຼື ວັນລາ, ສະຖານະ ແລະ ຄົ້ນຫາພະນັກງານ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="leave-approval-table"]',
    content: "ຕາຕະລາງຄຳຂໍລາ. ກົດເບິ່ງ, ອະນຸມັດ ຫຼື ປະຕິເສດຕາມສະຖານະ.",
    placement: "top",
  },
];
